import { Create, Search } from "@mui/icons-material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState, useContext, useEffect } from "react"
import OneButton from "../../../Components/OneButton/OneButton"
import OneInput from "../../../Components/OneInput/OneInput"
import OneTable from "../../../Components/OneTable/OneTable"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { CadastroEvento } from "./CadastroEvento/CadastroEvento"
import { prioridades } from "../../../Utils/optionsEventos"
import { filtroTextoPesquisa, limpaAudio } from "../../../Utils/Utils"

const PrioridadeCell = ({ idPrioridade }) => {
    if (idPrioridade > 4) {
        idPrioridade = 4
    }
    const prioridade = prioridades.filter((prioridade) => prioridade.value == idPrioridade)[0]

    return (
        <p style={{ color: prioridade.color }}>{prioridade.nome}</p>
    )
}

const EventosConfig = () => {
    const [openCadastro, setOpenCadastro] = useState(false)
    const [idToEdit, setIdToEdit] = useState(null)
    const [descricaoEvento, setDescicaoEvento] = useState('')

    const tableColumns = [
        {
            name: 'Evento',
            selector: row => row.evento,
            grow: 0.4
        },
        {
            name: 'Descrição',
            selector: row => row.descricao,
            grow: 3
        },
        {
            name: 'Tempo Espera',
            selector: row => row.tempo_medio_espera ? row.tempo_medio_espera : "00:00:00",
            grow: 1.5
        },
        {
            name: 'Tempo Médio',
            selector: row => row.tempo_medio_atendimento ? row.tempo_medio_atendimento : "00:00:00",
            grow: 1.5
        },
        {
            name: 'APP',
            selector: row => row.mostrar_app ? "Sim" : "Não",
            grow: 0
        },
        {
            name: 'Prioridade',
            cell: row => <PrioridadeCell idPrioridade={row.prioridade} />,
            grow: 1
        },
        {
            name: 'Vai p/ Tela',
            selector: row => row.vai_para_tela ? "Sim" : "Não",
            grow: 1
        },
        {
            name: 'Equipe',
            selector: row => row.equipe?.descricao ? row.equipe.descricao : "Sem equipe",
            grow: 2
        },
        {
            name: 'Editar',
            cell: (row) => <Create sx={{ cursor: 'pointer' }} onClick={() => { editEvent(row.id); setDescicaoEvento(row.evento) }} />,
            button: true
        }
    ]

    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [filterText, setFilterText] = useState('')
    const [textToSearch, setTextToSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [eventList, setEventList] = useState(false)
    const filteredDataList = filtroTextoPesquisa(eventList, filterText, ['evento', 'descricao'])

    const handleSearch = (event) => {
        event.preventDefault()
        setFilterText(textToSearch)
    }

    const handleChange = (event) => {
        setTextToSearch(event.target.value)
    }

    const getWsResponse = (msg) => {
        setEventList(msg.data.eventos)
        setLoading(true)
    }

    useEffect(() => {
        addRoute("buscarTodosEventos", getWsResponse)
        sendWs("buscarTodosEventos")
    }, [])

    const editEvent = (id) => {
        setIdToEdit(id)
        setOpenCadastro(true)
    }

    useEffect(() => {
        if (!openCadastro) {
            const evento = idToEdit
            limpaAudio(evento, 1)
        }
    }, [openCadastro])

    return (
        <Grid xs={12} sx={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'column' }} flexDirection="column" rowGap={1}>
            {openCadastro && idToEdit &&
                <CadastroEvento
                    openCadastro={openCadastro}
                    setOpenCadastro={setOpenCadastro}
                    idToEdit={idToEdit}
                    setIdToEdit={setIdToEdit}
                    descricaoEvento={descricaoEvento}
                />
            }
            <Grid container xs={12} sx={{ alignItems: 'center', height: '50px' }}>
                <Grid xs={12} sm={6}>
                    <form
                        id="eventos-search"
                        onSubmit={handleSearch}
                    // defaultValue={initialData}
                    >
                        <Grid container columnGap={1} xs={12} sx={{ alignItems: 'center' }}>
                            <Grid xs={6} sm={7.5}>
                                <OneInput name="pesquisar" onChange={handleChange} />
                            </Grid>
                            <Grid xs={4} sm={4}>
                                <OneButton
                                    id="button_teste"
                                    color="one_primary"
                                    variant="contained"
                                    type="submit"
                                    IconStart={Search}
                                >
                                    Pesquisar
                                </OneButton>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
                {/* <Grid xs={6} sx={{ alignItems: 'center' }}>
                    <Grid container justifyContent="flex-end">
                        <Button
                            id="button_teste"
                            color="one_primary"
                            variant="contained"
                            onClick={() => { setIdToEdit(null); setOpenCadastro(true) }}
                            sx={{ width: '148px', height: '30px' }}
                        >
                            <AddCircle sx={{ marginRight: '7px' }} />
                            Novo
                        </Button>
                    </Grid>
                </Grid> */}
            </Grid>

            <Grid container xs={12} sx={{
                // padding: '5px',
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                display: 'flex',
                flexGrow: 1,
                flexBasis: 'auto'
                // overflowY: 'scroll',
                // "::-webkit-scrollbar": {
                //     width: "6px",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-track": {
                //     background: "#D9D9D9",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb": {
                //     background: "#888",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb:hover": {
                //     background: "#555",
                //     borderRadius: '5px'
                // }
            }}>
                {eventList &&
                    <OneTable
                        columns={tableColumns}
                        data={filteredDataList}
                        progressPending={!loading}
                        dobleClickCallback={editEvent}
                    // pagination
                    // paginationPerPage={rowsPage}
                    // paginationRowsPerPageOptions={[rowsPage, 5, 10, 15, 20, 25, 30]}
                    // paginationComponentOptions={ { rangeSeparatorText: "de", rowsPerPageText: 'Itens por página' } }
                    />
                }
            </Grid>
        </Grid>
    )
}

export default EventosConfig
